import React from 'react';
import PropTypes from 'prop-types'

const CompanyAvatar = ({className, name, src, onClick, size,}) => {
  return (
    <div
      onClick={onClick}
      className={`company-avatar ${size} ${className}`}
    >
      {src ? (
        <img
          className="s-w-full s-h-full object-contain"
          src={src}
          alt={`Logo de ${name}`}/>
      ) : (
        <div className="s-bg-blue small-radius s-cross-center s-main-center s-w-full s-h-full">
          <p className="t4 s-color-white s-mb-0">{name.substring(0, 1).toUpperCase()}</p>
        </div>
      )}
    </div>
  );
};

CompanyAvatar.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  src: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.string,
}

CompanyAvatar.defaultProps = {
  onClick: () => {},
  className: '',
  src: '',
  size: 's-w-24px s-h-24px'
}

export default CompanyAvatar;
